module.exports = __webpack_public_path__ + "img/hip-hop.1c7195b8.png";